import { ZorgVerzekeringsWetRates } from './interface';

export const rates: ZorgVerzekeringsWetRates = {
    employed: {
        2018: [ { to: 54_614, percentage: 6.9 } ],
        2019: [ { to: 55_927, percentage: 6.95 } ],
        2020: [ { to: 57_232, percentage: 6.7 } ],
        2021: [ { to: 58_311, percentage: 7 } ],
        2022: [ { to: 59_706, percentage: 6.75 } ],
        2023: [ { to: 66_956, percentage: 6.68 } ],
        2024: [ { to: 66_956, percentage: 6.68 } ]
    },
    notEmployed: {
        2018: [ { to: 54_614, percentage: 5.65 } ],
        2019: [ { to: 55_927, percentage: 5.7 } ],
        2020: [ { to: 57_232, percentage: 5.45 } ],
        2021: [ { to: 58_311, percentage: 5.75 } ],
        2022: [ { to: 59_706, percentage: 5.5 } ],
        2023: [ { to: 66_956, percentage: 5.43 } ],
        2024: [ { to: 66_956, percentage: 5.43 } ]
    }
};
